import { IEventStatus } from "../BuildStatus";
import { isFlight } from "src/redux/reducers/FlightTimelineReducer";
import { FlightChip } from "src/components/Flights/FlightChip";
import { EventChip } from "src/components/Flights/EventChip";
import classNames from "classnames";
import { StatusIcon } from "../StatusIcon";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";

export const PendingEventStatus = (props: IEventStatus): JSX.Element => {
  const { status, statusMessage } = props;

  return (
    <div className={classNames("event_status", status)}>
      <div className="pending_chip">{isFlight(props) ? <FlightChip data={props} /> : <EventChip data={props} />}</div>

      <div className="status_message">
        <DoubleArrowIcon className="status_arrow" />
        <StatusIcon className="status_icon" state={status} tooltipMessage={statusMessage} />
      </div>
    </div>
  );
};
